/* Copyright 2021, Milkdown by Mirone. */
import { findChildren } from '@milkdown/utils';
import { Decoration, DecorationSet } from 'prosemirror-view';
import { highlight } from 'refractor';
const flatNodes = (nodes, className = []) => nodes.flatMap((node) => node.type === 'element'
    ? flatNodes(node.children, [...className, ...(node.properties.className || [])])
    : [{ text: node.value, className }]);
export function getDecorations(doc, name) {
    const decorations = [];
    findChildren((node) => node.type.name === name)(doc).forEach((block) => {
        let from = block.pos + 1;
        const { language } = block.node.attrs;
        if (!language)
            return;
        const nodes = highlight(block.node.textContent, language);
        flatNodes(nodes).forEach((node) => {
            const to = from + node.text.length;
            if (node.className.length) {
                const decoration = Decoration.inline(from, to, {
                    class: node.className.join(' '),
                });
                decorations.push(decoration);
            }
            from = to;
        });
    });
    return DecorationSet.create(doc, decorations);
}
//# sourceMappingURL=get-decorations.js.map